"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var _react2 = require("@emotion/react");

var _nanoid = require("nanoid");

var _theme = _interopRequireDefault(require("../../theme/theme"));

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Switch = function Switch(_ref) {
  var className = _ref.className,
      name = _ref.name,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return null;
  } : _ref$onChange;

  var _id = (0, _react.useRef)((0, _nanoid.nanoid)());

  var _useState = (0, _react.useState)(checked),
      _useState2 = _slicedToArray(_useState, 2),
      isChecked = _useState2[0],
      setIsChecked = _useState2[1];

  var handleChange = function handleChange() {
    if (disabled) return;

    var _checked = !isChecked;

    setIsChecked(_checked);
    onChange(_checked);
  };

  return (0, _react2.jsx)("label", {
    css: (0, _react2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        box-sizing: content-box;\n        display: inline-block;\n        position: relative;\n        height: ", ";\n        width: ", ";\n        top: ", ";\n        margin-top: calc(-1 * ", ");\n\n        border: ", " solid ", ";\n        border-radius: ", ";\n\n        background: ", ";\n        color: ", ";\n\n        cursor: pointer;\n        transition: all 0.15s;\n\n        ", "\n\n        ", "\n          \n        }\n      "])), _theme["default"].spaceOneAndHalf, _theme["default"].spaceFour, _theme["default"].spaceHalf, _theme["default"].spaceQuarter, _theme["default"].borderSizeLight, _theme["default"].colorDarkTemp, _theme["default"].spaceOne, isChecked ? _theme["default"].colorThemeTemp : _theme["default"].colorLightTemp, _theme["default"].colorDarkTemp, !disabled && "\n          @media (hover: hover) {\n            &:hover {\n              filter: brightness(1.2);\n            }\n          }\n\n          &:active:not([disabled]) {\n            transform: scale(0.925);\n          }\n          ", disabled && "\n          cursor: default;\n          opacity: 0.5;\n          "),
    htmlFor: _id.current
  }, (0, _react2.jsx)("input", {
    id: _id.current,
    className: className,
    name: name,
    css: (0, _react2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          width: 0;\n          height: 0;\n          opacity: 0;\n          position: absolute;\n          pointer-events: none;\n        "]))),
    onChange: handleChange,
    checked: isChecked,
    disabled: disabled,
    type: "checkbox"
  }), (0, _react2.jsx)("span", {
    css: (0, _react2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          box-sizing: content-box;\n          position: absolute;\n          top: calc(\n            -1 * ", " - 1 * ", "\n          );\n          left: calc(-1 * ", ");\n\n          width: ", ";\n          height: ", ";\n\n          border: ", " solid ", ";\n          border-radius: ", ";\n\n          background: ", ";\n\n          transform: ", ";\n          transition: transform 0.15s;\n        "])), _theme["default"].borderSizeRegular, _theme["default"].spaceQuarter, _theme["default"].borderSizeRegular, _theme["default"].spaceTwo, _theme["default"].spaceTwo, _theme["default"].borderSizeRegular, _theme["default"].colorDarkTemp, _theme["default"].spaceOne, _theme["default"].colorLightTemp, isChecked ? "translateX(calc(100% - " + _theme["default"].borderSizeRegular + " * 2))" : "translateX(0)")
  }));
};

Switch.propTypes = {
  className: _propTypes["default"].string,
  name: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  checked: _propTypes["default"].bool,
  onChange: _propTypes["default"].func
};
var _default = Switch;
exports["default"] = _default;